if (!customElements.get('backorder-pop-up')) {
    class BackorderPopup extends HTMLElement {
      constructor() {
        super();
        const target_id=this.dataset.targetId;
        this.backorder_details = this.querySelector('#'+target_id);
        var modal = this.parentElement.querySelector('#myModal-backorder-'+target_id);
        this.closebtn = modal.querySelector('.modal-content-'+target_id+'>.modal-close');
        this.bindEvents();
        this.modal=modal;
      }
  
      bindEvents() {
          if(this.backorder_details)
            this.backorder_details.addEventListener('click', this.handleDetailsClick.bind(this));
          this.closebtn.addEventListener('click', this.close.bind(this));
          
          this.documentClickHandler = this.handleDocumentClick.bind(this);
          document.addEventListener('click', this.documentClickHandler);
        }
      /**
       * Handles 'click' events on the document.
       * @param {object} evt - Event object.
       */
      handleDetailsClick(evt) {
        const target_id=this.dataset.targetId;
        //var modal = this.parentElement.querySelector('#myModal-backorder-'+target_id);
        var modal=this.modal;
        if(modal){
          if(!this.modal_parent)
            this.modal_parent=modal.parentElement;
          modal.style.display = "block";
          this.modal.isShow=true;
         document.body.appendChild(modal);
          if(document.getElementById("main-content")){
              const main_content= document.getElementById("main-content");
              main_content.style.position="relative";
              main_content.style.zIndex =30;
              if(document.getElementsByClassName("product-info product-info--sticky").length>0)
                document.getElementsByClassName("product-info product-info--sticky")[0].style.zIndex =10;
          }
        }
      }
  
      /**
       * Closes the cart drawer.
       */
      close() {
        const target_id=this.dataset.targetId;
        //var modal = document.querySelector('body>#myModal-backorder-'+target_id);
        var modal=this.modal;
        if(modal){
            this.modal.isShow=false;
            modal.style.display = "none";
            if(this.modal_parent)
              this.modal_parent.appendChild(modal);
            if(document.getElementById("main-content"))
            {
                const main_content= document.getElementById("main-content");
                main_content.style.zIndex =0;
            }
        }
      }
      handleDocumentClick(evt) {
            if (!evt.target.matches('.backorder-modal')) return;

            // Close the modal if it's open
            if (this.modal && this.modal.isShow) {
                this.modal.isShow=false;
                this.close();
            }
        }
    }

    customElements.define('backorder-pop-up', BackorderPopup);
}
